import { ReactNode } from "react";
import cn from "classnames";

import { Panel as CommonPanel, PanelProps as CommonPanelProps, Icon, IconProps } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Bold } from "capitalrx-components-2.0/lib/typography";

import { Body } from "@/basic/components";

import { useCheckCurrentScreen } from "@/basic/hooks";

import styles from "./styles.module.scss";

export interface StepsContainerProps extends CommonPanelProps, IconProps {
  active?: boolean;
  title: ReactNode;
  description: ReactNode;
}

export const StepsContainer = (props: StepsContainerProps) => {
  const { active, title, className, name, size = "regular", color = "turquoise", description } = props;

  const stepsContainerClass = cn(styles["StepsContainer"], { [styles["active"]]: active }, className);

  const stepsContentClass = cn({ [styles["InactiveStepsContentClass"]]: !active });

  const screen = useCheckCurrentScreen();
  const wideScreen = screen === "desktop" || screen === "tablet";

  const titleContent = active ? <Bold>{title}</Bold> : title;

  return (
    <CommonPanel {...props} className={stepsContainerClass}>
      <Shelf>
        <Icon name={name} size={size} color={color} />
        <Stack alignment="left" spacing="mini" className={stepsContentClass}>
          <Body size="mini">{titleContent}</Body>
          <Body size="mini">{description}</Body>
        </Stack>

        {!wideScreen && <Shelf.Spacer />}
      </Shelf>
    </CommonPanel>
  );
};
